import React from "react";
import useTitle from "../useTitle";

const MLQuees = () => {

    useTitle("Machine Learning qué es");

    return(
        <React.Fragment>
         <header 
            className="w3-container w3-center w3-padding-64 w3-light-grey" 
            style={{ marginBottom: '-64px' }}
        >
            <h1><b>Machine Learning qué es</b></h1>
            <img src="logo-gif-1.gif" alt="Aprender IA Logo" style={{ width: '200px' }} />
            <div 
                className="w3-container w3-center" 
                style={{ margin: '0 auto', width: '80%' }}
            >
                <p className="w3-xlarge">En este video explicamos qué es el Machine Learning.</p>
                <p className="w3-xlarge">¿Empezamos?<br />⬇️⬇️⬇️</p>
            </div>
        </header>

            <section style={{position: 'relative'}}>
            <div className="custom-shape-divider-bottom-1748065471">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" className="shape-fill"></path>
                </svg>
            </div>
            </section>

            <div className="w3-container w3-center w3-flex w3-black w3-padding-64" style={{flexWrap: 'wrap', justifyContent:'center'}}>
                <div className="w3-card-4 w3-twothird">
                    <div className="w3-container w3-padding-32 livecard" >
                        <iframe className="yt-video card-image" src="https://www.youtube.com/embed/80-2uVzSqQs" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen=""></iframe>
                    <h3><b>Machine Learning qué es</b></h3>
                    <p className='w3-xlarge'>Descubre qué es el Machine Learning.</p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default MLQuees;